import {
  Button,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { ROUTES_PATH } from 'config/constants';
import theme from '../theme';

const {
  images: { LogoLinkpickBlanc },
} = theme;


const InfoLinkpick = () => {
  const {
    classes,
    css,
    global,
    cx,
  } = useStyles(styles);

  const { push } = useRouter();

  const goToHome = () => {
    window.location.href = 'https://linkpick.fr/';
  };
  

  return (
    <>
      <div className={classes.imgContainer}>
        <img
          alt="Linkpick"
          className={classes.logo}
          src={LogoLinkpickBlanc}
          onClick={goToHome}
        />
        <div className={classes.linkContainer}>
          <a className={cx(global.title, classes.link)} href="https://linkpick.fr/conditions-generales-utilisation/" target="_blank">CGU</a>
          <a className={cx(global.title, classes.link)} href="https://linkpick.fr/mentions-legales/" target="_blank">Mentions légales</a>
        </div>
        <a className={cx(global.title, classes.link)} href="https://linkpick.fr/politique-de-confidentialite/" target="_blank">Politique de confidentialité</a>
      </div>
      <div className={classes.buttonContainer}>
        <Button
          color="primary"
          className={classes.signup}
          onClick={() => push(ROUTES_PATH.SIGN_UP)}
          variant="outlined"
          disableElevation
        >
          S'inscrire
        </Button>
        <Button
          color="primary"
          className={classes.signin}
          onClick={() => push(ROUTES_PATH.SIGN_IN)}
          variant="contained"
          disableElevation
        >
          Se connecter
        </Button>
      </div>
    </>
  );
};

const styles = ({ spacing }) => ({
  rightHeader: {
    backgroundColor: "#0060F9",
    height: "178px",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    textAlign: "center",
  },
  logo: {
    width: '250px',
    cursor: 'pointer',
    '@media (max-width:500px)': {
      width: '150px',
    },
  },
  signup: {
    borderRadius: '10.00px',
    padding: '10px 20px',
    width: '100%',
    '&:hover': {
      backgroundColor: 'white',
      color: '#0060F9',
    },
    '@media (max-width:500px)': {
      padding: '5px 15px',
    },
  },
  signin: {
    borderRadius: '10.00px',
    padding: '15px 30px',
    border: '1px white solid',
    width: '100%',
    '&:hover': {
      backgroundColor: '#0060F9',
      color: 'white',
    },
    '@media (max-width:500px)': {
      padding: '5px 15px',
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '70%',
    alignItems: 'center',
  },
  linkContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  link: {
    color: 'white',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  }
});

export default InfoLinkpick;
